import * as moment from 'moment';
import 'moment/locale/sv';

moment.locale('sv');

const FromNow = ({timestamp}) => (
    moment.unix(timestamp).fromNow()
);

const CurrentWeek = () => (
    moment().week()
);

const Format = ({ timestamp }) => (
    moment.unix(timestamp).format('DD/MM YYYY').toString()
)

export { FromNow, CurrentWeek, Format };



// WEBPACK FOOTER //
// ./src/components/Date.js